import {
  faEdit,
  faPlus,
  faTrophy,
  faClock,
  faCheckCircle,
  faTimesCircle,
  faBan,
  faMoneyBillWave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Badge } from "@themesberg/react-bootstrap";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { resumeSales } from "../../../../controller/api/__classic__/result";

const notHaveResultYet = (
  <Badge bg="gray-200" className="text-dark fw-bold px-3 py-2">
    <FontAwesomeIcon icon={faClock} className="me-2 text-muted" />
    Chưa có kết quả
  </Badge>
);

const cannotGetResult = (
  <Badge bg="danger" className="text-white">
    Không lấy được
  </Badge>
);

export const TableRow = (props) => {
  const {
    id,
    handleAddResult,
    resultDate,
    ClassicLotteryChannel,
    ClassicLotteryStorage,
    result,
    status,
    onCalculateRewardPress,
    totalRewaredTickets,
    totalUnRewardTickets,
    totalRewaredUnmarketableTickets,
    totalUnRewardUnmarketableTickets,
  } = props;

  const [cookies] = useCookies(["lottmekong"]);

  const linkToStatistic = `/classic/statistic-by-ticket?resultId="${id}"`;

  const [statusState, setStatusState] = useState(status);

  const [resultData, setResultData] = useState(result);

  useEffect(() => {
    setStatusState(status);
  }, [status]);

  useEffect(() => {
    setResultData(result);
  }, [result]);

  const updateNewResult = useCallback(
    (newResult) => {
      setResultData(newResult);
      if (statusState === 0 || statusState === 1 || statusState === 2) {
        setStatusState(3);
      }
    },
    [statusState],
  );

  const resultTd = useMemo(() => {
    if (resultData && resultData.length > 0) {
      return (
        <div className="d-flex align-items-center">
          {typeof resultData === "string" && (
            <div
              className="bg-success text-white px-3 py-1 rounded fw-bold border border-success me-2 shadow-sm"
              style={{ minWidth: "120px", textAlign: "center", fontSize: "1.1rem" }}
            >
              {resultData}
            </div>
          )}
          {typeof resultData !== "string" && (
            <Badge bg="success" className="me-2 px-3 py-2 shadow-sm">
              <FontAwesomeIcon icon={faTrophy} className="me-1" /> Đã có kết quả
            </Badge>
          )}

          <Button
            variant="light"
            size="sm"
            className="text-primary border shadow-sm px-2 bg-white"
            onClick={() =>
              handleAddResult(id, resultData, updateNewResult, true, ClassicLotteryChannel.name)
            }
            title="Sửa kết quả"
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        </div>
      );
    }

    if (statusState === 0 || statusState === 1 || statusState === 2) {
      return (
        <Button
          variant="outline-primary"
          size="sm"
          className="px-3 shadow-sm border-2 fw-bold"
          onClick={() => handleAddResult(id, resultData, updateNewResult, true, ClassicLotteryChannel.name)}
        >
          <FontAwesomeIcon icon={faPlus} className="me-1" /> Nhập kết quả
        </Button>
      );
    } else if (statusState === 3 || statusState === 4 || statusState === 5) {
      return cannotGetResult;
    }

    return notHaveResultYet;
  }, [handleAddResult, id, resultData, statusState, updateNewResult]);

  const inputTicketCount = (ClassicLotteryStorage || []).length;

  const hasResult = useMemo(() => {
    if (typeof resultData === "string") {
      return resultData.trim() !== "";
    }
    return Array.isArray(resultData) && resultData.length > 0;
  }, [resultData]);

  const onResumeSale = useCallback(
    async (resultId) => {
      const resp = await resumeSales(cookies.lottmekong, resultId);
      if (resp) {
        const result = setStatusState(0);
        if (result != null) {
          window.location.reload();
        }
      } else {
        alert("Có lỗi xảy ra");
        return false;
      }
    },
    [cookies.lottmekong],
  );

  const hasCalculatedReward = useMemo(() => {
    const rewardedTotals =
      Number(totalRewaredTickets || 0) +
      Number(totalUnRewardTickets || 0) +
      Number(totalRewaredUnmarketableTickets || 0) +
      Number(totalUnRewardUnmarketableTickets || 0);

    return rewardedTotals > 0 || statusState === 4 || statusState === 5;
  }, [
    statusState,
    totalRewaredTickets,
    totalRewaredUnmarketableTickets,
    totalUnRewardTickets,
    totalUnRewardUnmarketableTickets,
  ]);

  const canCalculateReward = useMemo(() => {
    return hasResult && inputTicketCount > 0 && !hasCalculatedReward;
  }, [hasResult, inputTicketCount, hasCalculatedReward]);

  const statusTd = useMemo(() => {
    switch (statusState) {
      case 0:
      case 1:
        if (hasCalculatedReward) {
          return (
            <Badge bg="soft-success" text="success" className="px-3 py-2">
              <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
              Đã tính thưởng
            </Badge>
          );
        }

        if (hasResult) {
          return (
            <Badge bg="soft-primary" text="primary" className="px-3 py-2">
              <FontAwesomeIcon icon={faTrophy} className="me-2" />
              Đã có KQ
            </Badge>
          );
        }

        return (
          <Badge bg="soft-info" text="info" className="px-3 py-2">
            <FontAwesomeIcon icon={faClock} className="me-2" />
            Đang bán
          </Badge>
        );
      case 2:
        return (
          <Badge bg="soft-warning" text="warning" className="px-3 py-2">
            <FontAwesomeIcon icon={faBan} className="me-2" />
            Ngưng bán
          </Badge>
        );
      case 3:
        if (inputTicketCount === 0) {
          return (
            <Badge bg="soft-secondary" text="secondary" className="px-3 py-2">
              <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
              Nghỉ
            </Badge>
          );
        }
        return (
          <Badge bg="soft-primary" text="primary" className="px-3 py-2">
            <FontAwesomeIcon icon={faTrophy} className="me-2" />
            Đã có KQ
          </Badge>
        );
      case 4:
      case 5:
        return (
          <Badge bg="soft-success" text="success" className="px-3 py-2">
            <FontAwesomeIcon icon={faMoneyBillWave} className="me-2" />
            {statusState === 5 ? "Đã trả thưởng (Loto)" : "Đã trả thưởng"}
          </Badge>
        );
      default:
        return (
          <Badge bg="light" text="dark" className="px-3 py-2">
            N/A
          </Badge>
        );
    }
  }, [hasCalculatedReward, hasResult, inputTicketCount, statusState]);

  const actionTd = useMemo(() => {
    switch (statusState) {
      case 0:
      case 1:
      case 2:
      case 3:
        if (canCalculateReward) {
          return (
            <Button
              variant="primary"
              size="sm"
              className="rounded px-3 shadow-sm fw-bold"
              onClick={() => onCalculateRewardPress(id)}
            >
              Tính thưởng
            </Button>
          );
        }

        if (hasCalculatedReward) {
          return "";
        }

        if (statusState === 3 && inputTicketCount === 0) {
          return "";
        }

        if (statusState !== 2) {
          return "";
        }

        return (
          <Button
            variant="success"
            size="sm"
            className="rounded px-3 shadow-sm text-white fw-bold"
            onClick={() => onResumeSale(id)}
          >
            Mở bán lại
          </Button>
        );
      case 4:
      case 5:
        return (
          <div className="d-flex justify-content-center gap-2">
            <Button
              variant="outline-primary"
              size="sm"
              className="px-3 rounded fw-bold"
              onClick={() => onCalculateRewardPress(id)}
            >
              Tính lại
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              as={Link}
              className="px-3 rounded text-decoration-none fw-bold"
              to={linkToStatistic}
              target="_blank"
            >
              Thống kê
            </Button>
          </div>
        );
      default:
        return "";
    }
  }, [
    statusState,
    id,
    inputTicketCount,
    linkToStatistic,
    onCalculateRewardPress,
    onResumeSale,
    hasCalculatedReward,
    canCalculateReward,
  ]);

  return (
    <tr className="align-middle hover-bg-gray-100 transition-all">
      <td className="ps-4">
        <div className="d-flex align-items-center py-2">
          <div className="position-relative me-3">
            {ClassicLotteryChannel.logo ? (
              <img
                src={ClassicLotteryChannel.logo}
                alt={ClassicLotteryChannel.name}
                className="rounded-circle shadow-sm border border-light"
                style={{ width: "48px", height: "48px", objectFit: "cover" }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            ) : (
              <div
                className="rounded-circle bg-light d-flex align-items-center justify-content-center shadow-sm border border-light"
                style={{ width: "48px", height: "48px" }}
              >
                <span className="fw-bold text-muted small">
                  {ClassicLotteryChannel.name?.substring(0, 2).toUpperCase()}
                </span>
              </div>
            )}
          </div>
          <div>
            <div
              className="fw-bold text-dark lh-1 mb-1"
              style={{ fontSize: "16px" }}
            >
              {ClassicLotteryChannel.name}
            </div>
            <div className="small text-muted fw-semi-bold d-flex align-items-center">
              <FontAwesomeIcon icon={faClock} className="me-1 text-gray-500" style={{ fontSize: "0.8em" }} />
              {resultDate}
            </div>
          </div>
        </div>
      </td>

      <td>{resultTd}</td>
      <td className="text-center">{statusTd}</td>
      <td className="pe-4 text-center">{actionTd}</td>
    </tr>
  );
};
